import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    api: 'https://care.ssd-co.com/api',
    shopCart: JSON.parse(localStorage.getItem(`care_shop_cart_${localStorage.getItem('care_user_id')}`)) || []
  },
  getters:{

  },
  mutations: {
    addToCart: (state, item)=> {
      let existed = false
      state.shopCart.forEach(i => {
        if(i.id == item.id) existed = true
      });
      if(!existed) state.shopCart = [...state.shopCart, item]
      localStorage.setItem(`care_shop_cart_${localStorage.getItem('care_user_id')}`, JSON.stringify(state.shopCart))
     },
    removeFromCart: (state, id)=> {
      localStorage.setItem(`care_shop_cart_${localStorage.getItem('care_user_id')}`, JSON.stringify(state.shopCart.filter(item=> item.id !== id)))
      state.shopCart = state.shopCart.filter(item=> item.id !== id)
    },
    emptyTheCart: (state)=>{
      state.shopCart = [];
      localStorage.setItem(`care_shop_cart_${localStorage.getItem('care_user_id')}`, JSON.stringify([]))
    },
    addAllToShopCart(state, products){
      products.forEach(p => {
        let found = state.shopCart.find(s => s.id == p.id);
        if(!found) state.shopCart = [...state.shopCart, p]
      });
      localStorage.setItem(`care_shop_cart_${localStorage.getItem('care_user_id')}`, JSON.stringify(state.shopCart))
    }
  },
  actions: {
  },
  modules: {
  }
})
